import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { SessionForm } from "@/features/session/components/session.form";

export default function ScheduleSessionPage() {
  return (
    <div>
      <OnboardingHeader title="Schedule Session" className="mb-6" />

      <SessionForm />
    </div>
  );
}
